import { useEffect, useState } from "react";

// True once the visitor has scrolled the window. With `enabled` false it is true from
// the first render.
export function useAfterFirstScroll(enabled: boolean): boolean {
  const [hasScrolled, setHasScrolled] = useState(!enabled);

  useEffect(() => {
    if (!enabled || hasScrolled) return;

    // Already scrolled, e.g. the page was restored at a scroll position.
    if (window.scrollY > 0) {
      setHasScrolled(true);
      return;
    }

    const onScroll = () => setHasScrolled(true);
    window.addEventListener("scroll", onScroll, { once: true, passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [enabled, hasScrolled]);

  return hasScrolled;
}
